<template>
  <div
    class="m-[24px] border-[1px] border-[#E5E5E5] rounded-[14px]"
  >
    <div
      class="flex items-center justify-between gap-[1px] px-[20px] py-[16px] cursor-pointer group transition-colors duration-300"
      :class="{
        'border-b-[1px] border-[#E5E5E5]': !isCollapsed
      }"
      @click="handleToggleCollapse"
    >
      <span class="text-[#0A0A0A] font-meidum text-[16px] m-0">
        {{ title }}
      </span>

      <div class="flex items-center justify-end gap-[8px]">
        <Button
          v-if="!isSingleWarehouse"
          type="icon"
          class="!w-[32px] !h-[32px] hover:!bg-[#FEE2E2]"
          aria-label="Hapus jenis paket"
          @click="$emit('remove-warehouse')"
        >
          <span class="k-trash text-[#E31A1A] text-[20px]" />
        </Button>
        <Button
          type="ghost"
          class="!px-0"
        >
          <span
            class="k-arrow-down-1 text-black text-lg transition-transform duration-300 ease-in-out"
            :class="{ 'rotate-180': !isCollapsed }"
          />
        </Button>
      </div>
    </div>
    <div
      class="transition-all duration-300 ease-in-out m-0"
      :class="{'hidden' : isCollapsed}"
    >
      <div
        ref="contentRef"
      >
        <slot
          name="default"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from '@/@core/components/ui'
/**
 * Packing Form Container to wrap the packing form
 * and add the collapse functionality
 */
export default {
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    isSingleWarehouse: {
      type: Boolean,
      default: false,
    },
    isDefaultCollapsed: {
      type: Boolean,
      default: false,
    },
    warehousesUsed: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isCollapsed: this.isDefaultCollapsed,
    }
  },
  watch: {
    isDefaultCollapsed(newVal) {
      this.isCollapsed = newVal
    },
  },
  methods: {
    /**
     * Handles the toggle collapse.
     */
    handleToggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
</script>
